import { render, staticRenderFns } from "./ElementsSizeProvider.vue?vue&type=template&id=b5a4bcfa"
import script from "./ElementsSizeProvider.vue?vue&type=script&lang=ts"
export * from "./ElementsSizeProvider.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b5a4bcfa')) {
      api.createRecord('b5a4bcfa', component.options)
    } else {
      api.reload('b5a4bcfa', component.options)
    }
    module.hot.accept("./ElementsSizeProvider.vue?vue&type=template&id=b5a4bcfa", function () {
      api.rerender('b5a4bcfa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/uiSize/ElementsSizeProvider.vue"
export default component.exports